// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1clh3Vx6tDsGejLFG2EPmK","icon":"_3-8MaEglQJxPuBtUoupSTG"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/UserCardOverlayItem.module.css
// module id = 2352
// module chunks = 1